import { defineGameCard, onResolve } from '../authoring/index.js';
export const ArcBoltCard = defineGameCard({
    id: 'arc_bolt',
    gameplay: {
        type: 'SPELL',
        cost: 1,
        planning: { target: 'unit' },
    },
    presentation: {
        name: 'Дуговой разряд',
        description: 'Нанесите 2 урона выбранной карте на поле.',
        glyph: {
            // The fifth palette entry satisfies the shared 20×20 glyph contract;
            // this artwork uses only colors 1–4.
            colors: ['#10213A', '#FADD5E', '#403644', '#FBFDCE', '#FBFDCE'],
            rows: [
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
                '..1.....2.....2..1..',
                '.131.....2......211.',
                '.131122..22..222131.',
                '13334442244224444331',
                '13341242422444221331',
                '.1331.2422.222..131.',
                '.1312..2.........11.',
                '..1.....2...2....1..',
                '...........2........',
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'standalone_lab',
    abilities: [
        onResolve((ctx) => {
            const plan = ctx.plan;
            if (plan?.kind !== 'SPELL' || plan.targetInstanceId === undefined)
                return;
            ctx.ops.dealDamage({ kind: 'unit', instanceId: plan.targetInstanceId }, 2);
        }),
    ],
});
//# sourceMappingURL=arc-bolt.js.map